// Get Locker types
export const GET_LOCKER_TYPE_REQUEST = 'GET_LOCKER_TYPE_REQUEST';
export const GET_LOCKER_TYPE_SUCCESS = 'GET_LOCKER_TYPE_SUCCESS';
export const GET_LOCKER_TYPE_FAILURE = 'GET_LOCKER_TYPE_FAILURE';
